module.exports = __webpack_public_path__ + "static/media/turvasahko-white.239420dd.svg";